import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	updatedIssueHiddenTitle: {
		id: 'software.main.flags.card-create-unmapped-in-ip-board.updated-issue-hidden-title',
		defaultMessage: "Your issue has been created, but it's hidden by a filter",
		description: 'Title of the flag when the issue is filtered out by filters on IP board',
	},
	updatedIssueHiddenDescription: {
		id: 'software.main.flags.card-create-unmapped-in-ip-board.updated-issue-hidden-description',
		defaultMessage: 'Remove your filters to see it on your board.',
		description: 'Description of the flag when the issue is filtered out by filters on IP board',
	},
	clearFiltersActionText: {
		id: 'software.main.flags.card-create-unmapped-in-ip-board.clear-filters-action-text',
		defaultMessage: 'Clear filters',
		description: 'Text for the action button to clear filters',
	},
	updatedIssueHiddenTitleIssueTermRefresh: {
		id: 'software.main.flags.card-create-unmapped-in-ip-board.updated-issue-hidden-title-issue-term-refresh',
		defaultMessage: "Your work item has been created, but it's hidden by a filter",
		description: 'Title of the flag when the issue is filtered out by filters on IP board',
	},
	updatedIssueHiddenTitleIssueTerminologyRefreshM4: {
		id: 'software.main.flags.card-create-unmapped-in-ip-board.updated-issue-hidden-title-issue-terminology-refresh-m4',
		defaultMessage: "Your {workType} has been created, but it's hidden by a filter",
		description:
			'Title of the flag when the issue is filtered out by filters on IP board. Please translate as “work type {workType}”',
	},
});
